/**
 * Where the public website lives, seen from inside the application.
 *
 * The site sends people here to sign in, and until now there was no way back: somebody who
 * arrived at the workspace by mistake, or who wanted to read the pricing page again, had to
 * know the address and type it. A one-way link between two halves of the same product is a
 * dead end wearing a logo.
 *
 * Configured rather than hard-coded, for the same reason the site's own links are: the
 * addresses differ between a laptop and production, and neither should need a code change.
 *
 *   VITE_SITE_URL     the public website   dev http://localhost:3004
 *   VITE_SIGNUP_URL   create an account    defaults to VITE_SITE_URL + /signup
 *
 * Vite inlines these at build time in whichever app consumes this package, so they are public
 * by construction and must never hold a secret.
 */

const isDev = import.meta.env.DEV;

function configured(value: string | undefined, fallback: string): string {
  const trimmed = value?.trim();
  return trimmed ? trimmed.replace(/\/+$/, '') : fallback;
}

const site = configured(
  import.meta.env.VITE_SITE_URL,
  isDev ? 'http://localhost:3004' : 'https://clientma.com',
);

export const publicSite = {
  home: site,
  pricing: `${site}/pricing`,
  signUp: configured(import.meta.env.VITE_SIGNUP_URL, `${site}/signup`),

  /** "clientma.com" — for link text, without the scheme cluttering it. */
  label: site.replace(/^https?:\/\//, ''),
} as const;
